














































import { Component, Prop, Ref, Vue } from "vue-property-decorator";

import VModal from "@/components/VModal.vue";
import { ReportTemplate } from "@/models";
import {
  cascadeDeleteLeadIn,
  cascadeDeleteAutomaticReportNames,
  DELETE_IRREVERSIBLE_NOTICE,
  templateDisplayName,
} from "./reportTemplate";

@Component({
  components: {
    VModal,
  },
})
export default class TemplateDeleteModal extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly templates!: ReportTemplate[];
  @Prop({ type: Boolean, default: false }) readonly bulkMode!: boolean;
  @Prop({ type: Boolean, default: false }) readonly deleting!: boolean;

  @Ref("modal") readonly modal!: VModal;

  readonly irreversibleNotice = DELETE_IRREVERSIBLE_NOTICE;

  get title(): string {
    return this.bulkMode
      ? "Eliminare i template selezionati?"
      : "Eliminare il template?";
  }

  get displayName(): string {
    return this.templates.length ? templateDisplayName(this.templates[0]) : "";
  }

  get cascadeLeadIn(): string {
    return cascadeDeleteLeadIn(this.templates);
  }

  get cascadeAutomaticReportNames(): string[] {
    return cascadeDeleteAutomaticReportNames(this.templates);
  }

  show() {
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }
}
